<template>
  <div>
    <div class="q-mb-md" v-if="!isFilter">
      <div class="row justify-ends">
        <div class="col-md-6">
          <q-btn
            icon="add"
            @click="newFormModalOpen=!newFormModalOpen"
            size="sm"
            flat
            class="no-shadow"
            color="secondary"
          >Add New {{ column.label | singular }}</q-btn>
        </div>
        <div class="col-md-6">
          <q-btn
            label="view data"
            color="secondary"
            size="sm"
            :disabled="!modelHasOption"
            icon="remove_red_eye"
            @click="infoModalOpen=!infoModalOpen"
            flat
            class="no-shadow"
          ></q-btn>
        </div>
      </div>
    </div>
    <q-select
      v-if="loaded && options.length"
      :value="modelId"
      @input="handleChange"
      :options="options | qOptions(labelField)"
      :multiple="false"
      :align="column.align"
      hide-underline
      :color="!isFilter ? color: ''"
      :inverted-light="!isFilter"
      clearable
      filter
      autofocus-filter
    ></q-select>
    <!-- ADD NEW FORM -->
    <div v-if="addButton && template === 'form' && !isFilter">
      <q-modal
        v-model="newFormModalOpen"
        content-classes="q-pa-lg"
        content-css="min-width: 70vw; max-width: 95vw"
        no-backdrop-dismiss
        no-esc-dismiss
      >
        <div class="fit">
          <q-btn
            flat
            icon="close"
            class
            style="top: 0; right: 0; position: relative; float: right"
            @click="newFormModalOpen=false"
          ></q-btn>
          <div v-if="newFormModalOpen">
            <h3
              class="q-display-1 text-secondary capitalize no-margin"
            >Add New {{ column.label | singular }}</h3>
            <base-form
              v-if="relationResource"
              :resource="relationResource"
              :parent-resource="parentResource"
              @add="handleNew"
              :is-modal="true"
            >
              <div slot="goback" class="full-width q-mt-md q-pb-lg">
                <q-btn
                  icon="close"
                  label="Cancel / Close"
                  color="grey-6"
                  @click="newFormModalOpen=false"
                  flat
                />
              </div>
            </base-form>
          </div>
        </div>
      </q-modal>
      <!-- SHOW DETAILED INFO -->
      <q-modal
        v-model="infoModalOpen"
        content-classes="q-pa-lg"
        content-css="min-width: 70vw; max-width: 95vw"
      >
        <div v-if="modelHasOption">
          <div class="q-pb-md">
            <span
              class="text-primary q-title"
            >{{ modelHasOption[labelField] || `(no data for ${labelField})` }} Info</span>
          </div>
          <div class="q-pb-md">
            <model-card-view :model="modelHasOption" :resource="relationResource">
              <div slot="actions" slot-scope="props">
                <q-btn class="full-width" color="primary" v-close-overlay label="Close"/>
              </div>
            </model-card-view>
          </div>
        </div>
      </q-modal>
    </div>
  </div>
</template>
<script>
  import ModelCardView from '../list/ModelCardView'

  export default {
  name: 'SelectOneField',
  components: { ModelCardView },
  props: {
    color: {
      type: String,
      default: 'deep-purple-1'
    },
    value: {
      type: [Object, String, Number],
      default: () => ''
    },
    addButton: {
      type: Boolean,
      default: () => true
    },
    column: {
      type: Object,
      required: true
    },
    _options: {
      type: Array,
      default: () => []
    },
    isFilter: {
      type: Boolean,
      default: () => false
    },
    stackLabel: {
      type: String,
      default: () => null
    },
    config: {
      type: Object,
      default: () => {}
    },
    template: {
      type: String,
      default: () => 'form'
    }
  },
  data () {
    return {
      loaded: false,
      isLoading: false,
      selected: null,
      newFormModalOpen: false,
      infoModalOpen: false,
      options: []
    }
  },
  computed: {
    labelField () {
      return this.column.relation ? this.column.relation.label : this.column.label
    },
    modelHasOption () {
      return this.options ? this.options.find(opt => parseInt(opt.id) === this.modelId) : false
    },
    resource () {
      return this.column.relation && this.column.relation !== 'self' ? this.column.relation.namespace : null
    },
    apiUrl () {
      return this.relationResource ? this.$store.state[this.relationResource].apiEndpoint : ''
    },
    modelId () {
      return this.value && typeof this.value === 'object' && this.value.id ? this.value.id : typeof this.value === 'number' ? this.value : null
    },
    relationResource () {
      return this.column.relation ? this.column.relation.namespace : null
    },
    parentResource () {
      return this.resource || this.$route.meta.resource
    }
  },
  methods: {
    handleChange (id) {
      if (!id) {
        // // console.log('>> emit remove')
        this.$emit('remove')
        return
      }
      // // console.log(`${this.resource} >> CHANGE >> ${id}`)
      if (id === this.modelId && this.modelHasOption) {
        return
      }
      const option = this.options.find(o => parseInt(o.id) === parseInt(id))
      if (option) {
        if (this.isFilter) {
          this.$emit('apply', { id: option.id })
        } else {
          this.$emit('change', option)
        }
        return true
      } else {
        this.fetchModel().then(model => {
          const { id } = model
          if (id) {
            const option = this.options.find(o => parseInt(o.id) === parseInt(id))
            if (option) {
              if (this.isFilter) {
                this.$emit('apply', { id: option.id })
              } else {
                this.$emit('change', option)
              }
            }
          }
        })
      }
    },
    handleNew (model) {
      this.options.push(model)
      this.$emit('change', model)
      this.newFormModalOpen = false
    },
    async fetchModel () {
      const id = this.modelId
      if (!this.resource || !this.apiUrl || !id) {
        return Promise.resolve()
      }
      try {
        const { data } = await this.$axios.get(`${this.apiUrl}/${id}`)
        if (data) {
          this.options.push(data)
        }
        return Promise.resolve(data)
      } catch (e) {
        return Promise.reject(e)
      }
    },
    async fetchOptions () {
      if (this.resource && this.apiUrl) {
        try {
          // // console.log(`-- init fetchAll ${this.resource}`)
          let url = this.apiUrl
          url = url.replace('/api/', '/api/odata/')
          url = `${url}/paginate`
          let params = {
            limit: 100,
            page: 1,
            sort: this.labelField || null,
            $filter: 'removalDate eq null'
          }
          if (this.config && this.config.hasOwnProperty('params')) {
            params = Object.assign({}, params, this.config.params)
          }
          const { data } = await this.$axios.get(url, {
            params
          })
          if (data && data.data) {
            this.$set(this, 'options', data.data)
            // // console.log(`-- complete fetch ${this.resource}`)
          }
          return Promise.resolve()
        } catch (e) {
          return Promise.reject(e)
        }
      }
    }
  },
  created () {
    // // console.log(`-- mounted ${this.resource}`)
    if (this._options && this._options.length) {
      // if props are given, use them!
      this.$set(this, 'options', this._options)
    }
    // initialize model so we at least get the model and option
    this.fetchOptions().then(() => {
      // // console.log(`-- complete fetchModel ${this.resource}`)
      this.$nextTick(() => {
        if (!this.modelHasOption) {
          this.fetchModel().then(() => {
            this.$set(this, 'loaded', true)
            // // console.log(`-- loaded ${this.resource}`)
          })
        } else {
          this.$set(this, 'loaded', true)
        }
      })
    })
  },
  watch: {
    modelId: {
      handler (id) {
        this.$set(this, 'selected', id)
        if (!this.modelHasOption && !!id) {
          this.fetchModel()
        }
      }
    }
  }
}
</script>
